/*
 Created by CHT 2020/10/11 10:01
 滑块
 */

import BaseItem from "../BaseItem"
import {
	DATA_TYPE__NUMBER,
	DEFAULT_VALUE__CUSTOM,
	DEFAULT_VALUE__FORMULA,
	DEFAULT_VALUE__RELATE_DATA,
	FORM_ITEM__SLIDING_BLOCK, FORM_ITEM__TABLE
} from "../types"
import {defaultValueInit} from "../utils"

class SlidingBlock extends BaseItem {
	constructor() {
		super()

		this.value = 0

		this.minValue = 0		   // 最小值
		this.maxValue = 100    // 最大值
		this.step = 1					 // 修改间隔
		this.manuallyEnter = 0 // 是否允许手动输入

		this.defaultValue = {
			defaultType: ''
		}
	}

  get title() {
    return this.fieldTitle || SlidingBlock._title
  }

  set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

SlidingBlock._title = '滑块'
SlidingBlock.type = FORM_ITEM__SLIDING_BLOCK
SlidingBlock.use = true
SlidingBlock.icon = 'iconfont icon-huakuai'

SlidingBlock.prototype.type = SlidingBlock.type
SlidingBlock.prototype.dataType = DATA_TYPE__NUMBER
SlidingBlock.prototype.defaultValueList = [
	{
		label: '不设置',
		value: {
			defaultType: ''
		}
	},
	{
		label: '自定义',
		value: defaultValueInit(DEFAULT_VALUE__CUSTOM)
	},
	{
		label: '公式',
		value: defaultValueInit(DEFAULT_VALUE__FORMULA)
	},
	{
		label: '关联数据',
		value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
	}
]
SlidingBlock.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '等于任意一个',
    method: 'in'
  },
  {
    name: '不等于任意一个',
    method: 'nin'
  },
  {
    name: '包含',
    method: 'like'
  },
  {
    name: '不包含',
    method: 'unlike'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
SlidingBlock.prototype.getValue = function () {
	return this.value
}
SlidingBlock.prototype.setValue = function (val) {
	if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
		return
	}
	this.value = val || 0
}
SlidingBlock.prototype.setConf = function (opts) {
	this.setBase(opts)
	if (opts.readOnly) this.readOnly = opts.readOnly
	if (opts.initialValue) this.initialValue = opts.initialValue
	if (opts.minValue) this.minValue = opts.minValue
	if (opts.maxValue) this.maxValue = opts.maxValue
	if (opts.step) this.step = opts.step
	if (opts.manuallyEnter) this.manuallyEnter = opts.manuallyEnter
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
}
SlidingBlock.prototype.getConf = function () {
	const base = this.getBase()
	return {
		...base,
		readOnly: this.readOnly,
		initialValue: this.initialValue,
		minValue: this.minValue,
		maxValue: this.maxValue,
		step: this.step,
		manuallyEnter: this.manuallyEnter,
		defaultValue: this.defaultValue
	}
}
SlidingBlock.prototype.valueToString = function (value) {
	value = value || this.value
	return value
}
export default SlidingBlock
